import {createSlice} from '@reduxjs/toolkit';
import {Project} from '../types';
import {getProject} from '../index';

const initialState: Project = {
    id: 0,
    name: '',
    note: '',
    isActive: false,
    isBillable: false,
    projectType: {id: 0, name: '', isDefault: false},
    employees: [],
    canEditClient: false,
    canEditProjectManager: false,
    canEditEmployees: false,
    canEditRoleForNotification: false,
}

const typeSplice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        clear: () => {
            return initialState
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getProject.fulfilled, (state, action) => {
            return action.payload;
        })
    }
})

export const { clear } = typeSplice.actions

export default typeSplice.reducer;
